// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__30NGt","importantInfo":"styles_importantInfo__2H8-j"};